import addStyles from '../addStyles';
import applyStylingConfiguration from '../applyStylingConfiguration';
import addDocumentCSS from '../addDocumentCSS';
import { STATIC_PATH } from '../../../constants';

/**
 * @method applyConfiguration
 */
const applyConfiguration = async (
  frame,
  bookAppearanceValuesContext,
  readerSettingsValues,
  fixedWidth = null,
  fixedHeight = null,
) => {
  const frameDocument = frame.contentDocument;

  // Add Readium CSS
  if (fixedWidth === null) {
    // Prepend readium-before to the beginning of the document head
    // and append readium-after to the end of the document head
    for (let suffix of ['before', 'after']) {
      const id = `redshelf-readium-${suffix}`;
      const readiumElementAlreadyAdded = Boolean(
        frameDocument.getElementById(id),
      );

      if (readiumElementAlreadyAdded) {
        continue;
      }

      await addStyles(
        frameDocument,
        {
          href: `${STATIC_PATH}/css/readium-${suffix}.css`,
          id,
        },
        null,
        suffix === 'before',
      );
    }

    frameDocument.body.classList.add('readium-enabled');
    applyStylingConfiguration(frame, bookAppearanceValuesContext);
  } else {
    frameDocument.body.classList.remove('readium-enabled');

    const currentZoomLevel = bookAppearanceValuesContext.fontSize || 1;
    const newStyle = {
      position: 'absolute',
      left: 0,
      transform: `translate(0px, 0px) scale(${currentZoomLevel})`,
      transformOrigin: 'top left',
      // iframe dimension is adjusted to meet the dimension of body, so no overflow required
      overflow: 'hidden',
      display: '',
    };

    // If the content width is smaller than the window width, center it and disable hz scrolling.
    const widthWithZoom = fixedWidth * currentZoomLevel;
    const contentToWindowRatio = widthWithZoom / window.innerWidth;
    if (contentToWindowRatio < 1) {
      newStyle.left = `calc(50% - ${widthWithZoom / 2}px)`;
    }

    Object.assign(frameDocument.body.style, newStyle);
  }

  // Ensure visibility is restored after styling is applied
  frameDocument.documentElement.style.visibility = '';

  // Inject RedShelf CSS into the iframe.
  await addDocumentCSS(
    frameDocument,
    readerSettingsValues,
    bookAppearanceValuesContext.theme,
    fixedWidth,
    fixedHeight,
  );
};

export default applyConfiguration;
